import axiosInstance from '../../config/AxiosConfig'
import {BACKEND_ENDPOINT, NOTIFICATION_ENDPOINT} from '../../Constants'

const USER_PATH = 'user'
const SUPPORT_TEAM_PATH = 'supportTeams'

//#region Custom User
export function getCustomPatientList(
    userId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/customUser/getAllPatients`, filterRequest, {
            params: {
                userId,
                pageNumber,
                pageRows,
                sortField,
                sortOrder,
            },
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}

export function countCustomPatientList(userId, filterRequest) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/customUser/countAllPatients`,
            filterRequest,
            {
                params: {
                    userId,
                },
            },
        )
        .then(res => res.data)
        .catch(error => console.log(error))
}
//#endregion

//#region User
//#region Generic
export function getDetailPatient(userId, id) {
    return axiosInstance
        .get(`${BACKEND_ENDPOINT}/${USER_PATH}/getById`, {
            params: {
                userId,
                id,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
export function getPagePatients(
    userId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${USER_PATH}/getPage`, filterRequest, {
            params: {
                userId,
                pageNumber,
                pageRows,
                sortField,
                sortOrder,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
export function getListPatients(userId, rows, dto, filterRequest) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${USER_PATH}/getList`, filterRequest, {
            params: {
                userId,
                rows,
                dto,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
export function createOrUpdatePatient(userId, data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${USER_PATH}/createOrUpdate`, data, {
            params: {
                userId,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function createOrUpdateBasicPatient(userId, data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${USER_PATH}/basic/createOrUpdate`, data, {
            params: {
                userId,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion

//#region Group Action
export function getUserSectionListOptions(userId, filterRequest) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${USER_PATH}/getPatientSectionList`,
            filterRequest,
            {
                params: {userId},
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
export function addPatientToHCP(userId, data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${USER_PATH}/addPatientToHCP`, data, {
            params: {userId},
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
export function dischargePatient(userId, id, data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${USER_PATH}/dischargePatient`, data, {
            params: {userId, id},
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
export function updateAccessConfig(userId, id, data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${USER_PATH}/updateAccessConfig`, data, {
            params: {userId, id},
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion
//#endregion

//#region Support Team
export function updateSupportTeam(userId, id, data) {
    return axiosInstance
        .post(
            `${NOTIFICATION_ENDPOINT}/${SUPPORT_TEAM_PATH}/updateSupportTeam`,
            data,
            {
                params: {userId, id},
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion
